<template>
  <b-card>
    <b-row>
      <b-col>
        <b-tabs>
          <b-tab v-if="checkRoles('configuration', 'LogList')" :title="$t('menu.logs.list')">
            <LogList></LogList>
          </b-tab>
          <b-tab v-if="checkRoles('configuration', 'DownloadData')" :title="$t('menu.downloaddata.list')">
            <DownloadData></DownloadData>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPermission } from '@/utils/checkRoles'
import LogList from '@/components/Dashboard/Views/log/LogList'
import DownloadData from '@/components/Dashboard/Views/log/DownloadData'

export default {
  computed: mapGetters({
    error: 'log/list/error',
    items: 'log/list/items',
    isLoading: 'log/list/isLoading',
    view: 'log/list/view'
  }),
  components: {
    DownloadData,
    LogList
  },
  created () {
    this.getPage()
  },

  methods: {
    ...mapActions({
      getPage: 'log/list/default'
    }),
    checkRoles (type, view = null, component = null) {
      return checkPermission(type, view, component)
    }
  }
}
</script>
